// src/Bloglists.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Bloglists.css';
import { IoArrowBack } from 'react-icons/io5';

const blogs = [
  { title: 'Message to Aliens', date: 'April 29, 2025', path: '/blog/0' },
  { title: 'Time Travel for Rookies', date: 'April 29, 2025', path: '/blog/1' },
];

export default function Bloglists() {
  const navigate = useNavigate();

  const pageStyle = {
    backgroundImage: "url('/assets/DraftHood_logo.png')",  // full-screen bg
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
    width: '100%',
  };

  return (
    <div style={pageStyle}>
      <div className="bloglists-container">
        {/* Back button */}
        <button className="back-btn" onClick={() => navigate('/blogs')}>
          <IoArrowBack size={28} />
        </button>

        <h1 className="bloglists-title">All Blogs</h1>
        <ul className="bloglists-list">
          {blogs.map((blog, idx) => (
            <li key={idx} className="bloglists-item">
              <button
                onClick={() => navigate(blog.path)}
                className="bloglists-btn"
              >
                {blog.title}
              </button>
              <span className="bloglists-date">{blog.date}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
